import React from 'react';
import { motion } from 'framer-motion';
import { IndustrySolutionCard, Solution } from './IndustrySolutionCard';
import {
  HiShoppingBag,
  HiCog,
  HiAcademicCap
} from 'react-icons/hi2';

const solutions: Solution[] = [
  {
    id: 'retail-ecommerce',
    title: 'Retail & E-commerce',
    description: 'Personalize journeys and optimize omnichannel operations.',
    icon: HiShoppingBag,
    image: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?auto=format&fit=crop&w=800&q=80',
    challenges: [
      'Inventory & Supply Resilience',
      'Customer Personalization',
      'Unified Commerce',
      'Marketing Attribution'
    ],
    solutions: [
      'Composable commerce builds',
      'Real-time recommendation engines',
      'Connected store analytics',
      'Global fulfillment orchestration'
    ],
    linkOverride: '/solutions/retail-ecommerce'
  },
  {
    id: 'manufacturing',
    title: 'Manufacturing & Automotive',
    description: 'Enable smart factories and connected product insights.',
    icon: HiCog,
    image: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?auto=format&fit=crop&w=800&q=80',
    challenges: [
      'Predictive Maintenance',
      'Connected Operations',
      'Supply Chain Visibility',
      'Product Quality'
    ],
    solutions: [
      'Industrial IoT data platforms',
      'Digital twin simulations',
      'Factory telemetry dashboards',
      'Automated quality inspection'
    ]
  },
  {
    id: 'education',
    title: 'Education',
    description: 'Transform learning experiences with digital platforms and analytics.',
    icon: HiAcademicCap,
    image: 'https://images.unsplash.com/photo-1503676260728-1c00da094a0b?auto=format&fit=crop&w=800&q=80',
    challenges: [
      'Student Engagement',
      'Learning Outcomes',
      'Platform Adoption',
      'Administrative Efficiency'
    ],
    solutions: [
      'Learning Management Systems',
      'Student portals & mobile apps',
      'Analytics & performance dashboards',
      'Virtual classroom platforms'
    ],
    linkOverride: '/solutions/education'
  }
];

export const SolutionsGrid: React.FC = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto mt-8">
      {solutions.map((solution, index) => (
        <IndustrySolutionCard
          key={solution.id}
          solution={solution}
          index={index}
        />
      ))}
    </div>
  );
};